import { Image as ImageShp } from "@shopify/hydrogen"
import { useEffect, useState } from "react"

export default function ImageLoad({src, alt, className}) {

  const [height, setHeight] = useState('');
  const [width, setWidth] = useState('');

  useEffect(()=>{
    let img = new Image();

    img.onload = ()=>{
        setHeight(img.height+'px')
        setWidth(img.width+'px')
    };

    img.src = src;
  },[])

  return (
  <>
    {height && (
      <ImageShp
        src={src}
        height={height}
        width={width}
        alt={alt}
        className={className}
      />
    )}
  </>)
}